import { useEffect, useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { useAppSelector } from 'src/hooks/hooks';
import CloseIcon from "@mui/icons-material/Close";


import {
  Avatar,
  CakeIcon,
  WorkIcon,
  getCelebrationEvents,
  getDaysUntil,
  getNumberSuffix,
  CelebrationWheel,
  CelebrationInformation,
} from 'src/utils/celebrationUtils'; 

const CelebrationItemList = ({ data }: { data: CelebrationInformation[] }) => {

  const { isLoading } = useAppSelector((state) => state.appReducer);
  // Tracks matched celebrations, current item index, and how many have been shown
  const [matchedCelebrations, setMatchedCelebrations] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [shownCount, setShownCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);


  const todayCelebrations = data.flatMap((celebration) =>
  getCelebrationEvents(celebration)
      .map((event) => ({
      ...event,
      employeeId: celebration.employeeId,
      employeeName: celebration.employeeName,
      anniversaryCount: celebration.anniversaryCount,
      milestone: celebration.milestone,
      birthday:celebration.birthday
      }))
      .filter((event) => getDaysUntil(event.date) === 0)
  );

  const isWheelActive = todayCelebrations.length > 3;


  useEffect(() => {
    if(!isLoading){
      const runCelebrationChecks = async () => {
        try {
          const user = JSON.parse(localStorage.getItem('user') || '{}');
          const todayKey = new Date().toISOString().slice(0, 10);
          const viewCount = JSON.parse(localStorage.getItem("gifviewCount") || "{}");
          const todayCount = viewCount[todayKey] || 0;

          const matchedCelebrations = todayCelebrations.filter(
            (celebration) => celebration.employeeId === user.EmployeeId
          );   

          if ( matchedCelebrations?.length && todayCount < 2) {
            setMatchedCelebrations(matchedCelebrations);
            setCurrentIndex(0); 
            setShownCount(1);
            setDialogOpen(true); 
            viewCount[todayKey] = todayCount + 1;
            localStorage.setItem("gifviewCount", JSON.stringify(viewCount));
          }
        } catch (error) {
          console.error("Failed to check if user's birthday is today. Please try again later.");
        }
      };    
      
      runCelebrationChecks();
    }
    
  }, [isLoading]);

  const handleDialogClose = () => {
    const nextIndex = currentIndex + 1;
    const nextCount = shownCount + 1;

    if (nextIndex < matchedCelebrations?.length && nextCount <= 3) {
      setCurrentIndex(nextIndex);
      setShownCount(nextCount);
    } else {
      setDialogOpen(false);
    }
  };

return (
  <>
    {isWheelActive ? (
      <CelebrationWheel events={todayCelebrations} />
    ) : (
      <div>
        { todayCelebrations?.map((event, index) => (
          <div
            key={`${event.employeeId}-${event.label}-${index}`}
            className="celebrations-item today-celebrations-item"
          >
            <div>
              <Avatar sx={{ bgcolor: '#1976d2', width: 35, height: 35, marginLeft: '5px', marginRight: '5px' }}>
                {event.employeeName
                  .split(" ")
                  .map(word => word.charAt(0).toUpperCase())
                  .join("")}
              </Avatar>
            </div>

            <div className='celebration-content-column'>
              <div className='celebration-header-row' style={{ alignItems: 'baseline' }}>
                <div>
                  {event.birthday && event.icon === CakeIcon && (
                    <span className="emp-name wheel-emp-name">Happy Birthday</span>
                  )}
                  {event.milestone && event.icon === WorkIcon && (
                    <span className="emp-name wheel-emp-name">
                      Happy {event.anniversaryCount}
                      {getNumberSuffix(event.anniversaryCount)} Work Anniversary
                    </span>
                  )}
                  <span className="emp-name wheel-emp-name"> {event.employeeName}</span>
                </div>
              </div>
            </div>

            <div className="celebrations-icon">
              {getDaysUntil(event.date) > 0 ? (
                <span>In {getDaysUntil(event.date)} {getDaysUntil(event.date) === 1 ? 'day' : 'days'}</span>
              ) : getDaysUntil(event.date) === 0 ? (
                <span>Today</span>
              ) : (
                <span>{Math.abs(getDaysUntil(event.date))} {getDaysUntil(event.date) === 1 ? 'day' : 'days'} ago</span>
              )}
              <event.icon sx={{ fontSize: '24px', marginRight: '4px', marginBottom: '4px', color: event.color }} />
            </div>
          </div>
        ))}
      </div>
    )}

    <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'transparent',
            boxShadow: 'none'
          }
        }}
      >
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent >
        <div className="celebration-gif-container">
          { matchedCelebrations?.length > 0 && (
            <>
              {matchedCelebrations[currentIndex]?.label === "Birthday" && (
                <img
                  className="celebration-gif"
                  src={`${process.env.PUBLIC_URL}/img/happy-birthday.gif`}
                  alt="Happy Birthday"
                />
              )}
              {matchedCelebrations[currentIndex]?.label === "Work Anniversary" && (
                <img
                  className="celebration-gif"
                  src={`${process.env.PUBLIC_URL}/img/work-anniversary.gif`}
                  alt="Work Anniversary"
                />
              )}
              <span className= {`celebration-text ${
                matchedCelebrations[currentIndex]?.label === "Birthday"
                  ? "birthday-celebration-text"
                  : "anniversary-celebration-text"
              }`}>
                {matchedCelebrations[currentIndex]?.employeeName} 
              </span>
            </>
          )}
        </div>       
      </DialogContent>
    </Dialog>
  </>
);

};

export default CelebrationItemList;